import React from "react";
import {Button} from "@/components/ui/button";
import Image from "next/image";
import {ProductSkeletonList} from "@/components/skeletons/ProductSkeleton";
import {ProductCard} from "@/components/ui/productCard";

export type ProductsListProps<TProduct extends { id: string | number }> = {
    category: { title: string; subTitle?: string };
    products: TProduct[];
    isLoading?: boolean;
    showAllButton?: boolean;
    onShowAll?: () => void;
    onPrevClick?: () => void;
    onNextClick?: () => void;
    caretIconSrc?: string;
    caretIconSize?: number; // square size used for width/height
    skeletonCount?: number;
    containerRef?: React.Ref<HTMLDivElement>;
};

export function ProductsList<TProduct extends { id: string | number }>(props: ProductsListProps<TProduct>) {
    const {
        category,
        products,
        isLoading = false,
        showAllButton = false,
        onShowAll,
        onPrevClick,
        onNextClick,
        caretIconSrc = "/assets/svgs/Icons/CaretDown.svg",
        caretIconSize = 16,
        skeletonCount = 10,
        containerRef,
    } = props;

    return (
        <section className=" flex flex-col gap-8 ">
            <div className="flex w-full flex-col items-center justify-between  sm:flex-row   ">
                <div className="flex flex-col">
                    <h3 className="font-garnettSemiBold text-2xl">{category.title}</h3>
                    {category.subTitle && <h6 className="m-0 text-sm">{category.subTitle}</h6>}
                </div>
                <div className="flex justify-between">
          <span className="flex gap-2">
            <Button className="sliderBtn" variant="ghost" size="icon" onClick={onPrevClick} aria-label="previous">
              <Image src={caretIconSrc} width={caretIconSize} height={caretIconSize} alt="caret"
                     className=" rotate-90 "/>
            </Button>
            <Button className="sliderBtn" variant="ghost" size="icon" onClick={onNextClick} aria-label="next">
              <Image src={caretIconSrc} width={caretIconSize} height={caretIconSize} alt="caret"
                     className=" -rotate-90 "/>
            </Button>
          </span>
                    {showAllButton && (
                        <Button className="p-2 text-sm font-medium" variant="link" onClick={onShowAll}>
                            Show All
                        </Button>
                    )}
                </div>
            </div>
            <div className="flex snap-mandatory gap-6 overflow-x-scroll py-4" ref={containerRef}>
                {isLoading && <ProductSkeletonList count={skeletonCount}/>}
                {!isLoading && products?.map((product: any) => <ProductCard key={product.id} {...product} />)}
            </div>
        </section>
    );
}
